import { z } from 'zod';

import { UuidSchema } from '../../common/id/id';
import { AnswerValueSchema } from '../../questions/answer-value-schema/answer-value-schema';
import { QuestionTypeSchema } from '../../questions/question-type/question-type';

/** One side of an edit: the stored value and, for option-backed types, how it reads. */
export const AnswerSnapshotSchema = z
  .object({
    value: AnswerValueSchema,
    valueLabels: z.array(z.string()),
  })
  .strict();

export type AnswerSnapshot = z.infer<typeof AnswerSnapshotSchema>;

/**
 * One review-gated answer an approved member edited (D6), as both the reviewer
 * and the member read it on a `re_review` case.
 *
 * `previous` is what a rejection restores. `hadPrevious` keeps "never answered"
 * apart from "answered blank": both snapshot as `null`, but restoring the first
 * deletes the row and restoring the second writes `null` back — and completion
 * counts them differently.
 */
export const AnswerChangeSchema = z
  .object({
    questionId: UuidSchema,
    questionKey: z.string().min(1),
    /** Already in the caller's locale (N5). */
    label: z.string().min(1),
    type: QuestionTypeSchema,
    hadPrevious: z.boolean(),
    previous: AnswerSnapshotSchema,
    next: AnswerSnapshotSchema,
    changedAt: z.iso.datetime(),
  })
  .strict();

export type AnswerChange = z.infer<typeof AnswerChangeSchema>;
